import capitalize from 'lodash-es/capitalize';
import type { MetaFunction } from 'react-router';

import { breadcrumbList } from '@jane/bloom/resources/meta/breadcrumbList';
import { canonicalTag } from '@jane/bloom/resources/meta/canonicalTag';
import { createMetaVariables } from '@jane/bloom/resources/meta/createMetaVariables';
import { getMetaDescription } from '@jane/bloom/resources/meta/description';
import { getRootLoaderData } from '@jane/bloom/resources/meta/getRootLoaderData';
import { parentMeta } from '@jane/bloom/resources/meta/parentMeta';
import { getMetaTitle } from '@jane/bloom/resources/meta/title';
import type { loader } from '@jane/bloom/routes/_menu.($storeSlug).deals.$dealId.$slug/route';

export const dealDetailRouteMeta: MetaFunction<typeof loader> = (args) => {
  const { customSEO, menuUrl, metaProps } = getRootLoaderData(args);
  const data = args.loaderData;

  // Match metaProps to available customSEO variables
  const metaVariables = createMetaVariables(metaProps, {
    rowName: 'Deals',
    specialName: capitalize(data?.currentSpecial?.title),
  });

  return [
    getMetaTitle(customSEO?.deal, metaVariables),
    getMetaDescription(customSEO?.deal, metaVariables),
    canonicalTag(args.location, menuUrl),
    breadcrumbList(data?.breadcrumbs, menuUrl),
    ...parentMeta(args),
  ];
};
